import { Link } from 'react-router'

import { useMenu } from '@entities/Menu'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface TopMenuNavigationProps {
  className?: string;
}

export default function TopMenuNavigation ({ className }: TopMenuNavigationProps) {
  const { menu, loading } = useMenu({ code: 'header-top' })

  if (loading || !menu?.menuItems?.length) {
    return null
  }

  return (
    <nav className={cn(styles.topMenuNav, className)}>
      <ul className={cn(styles.topMenuNav__list, 'reset-list')}>
        {menu.menuItems.map((item) => (
          <li key={item.id} className={styles.topMenuNav__item}>
            <Link to={item.link_url || '#'} className={styles.topMenuNav__link}>
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}
